import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <p>{`Vor Beginn der Live-Verkostung Link aufrufen. Dieser wird einen Tag vor der Verkostung per E-Mail zugesandt und ist unter Programm für jede Veranstaltung hinterlegt.`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      